import { createBrowserHistory } from '@remix-run/router';
import { useEffect } from 'react';
import { useLocation, Location } from 'react-router-dom';
import { BehaviorSubject, map } from 'rxjs';

export const history = createBrowserHistory({ window, v5Compat: true });

export const history$ = new BehaviorSubject<Location<any>>(history.location);
export const pathname$ = history$.pipe(
  map((location) => location?.pathname ?? '/')
);

export const useOnLocationChange = () => {
  const location = useLocation();
  useEffect(() => history$.next(location), [location]);
};
